import { render, staticRenderFns } from "./public-management.vue?vue&type=template&id=11498ddd&scoped=true"
import script from "./public-management.vue?vue&type=script&lang=js"
export * from "./public-management.vue?vue&type=script&lang=js"
import style0 from "./public-management.vue?vue&type=style&index=0&id=11498ddd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11498ddd",
  null
  
)

export default component.exports